module.exports = __webpack_public_path__ + "static/media/exo-latin-400italic.caa0dc5a.woff2";